
import { RootState, AppDispatch } from '../../store';

import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Link as RouterLink } from 'react-router-dom';
import { useForm } from "react-hook-form"

import { Grid, TextField, Checkbox, FormControlLabel, Button, Link, InputAdornment, IconButton, CircularProgress, Alert } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import { AuthLayout } from '../../layouts';
import { startRegisterNormalUser } from '../../store/auth';
import { regularExps } from '../../helpers/validators';


type Inputs = {
  name: string,
  email: string,
  password: string,
  acceptTerms: boolean
}

export const RegisterPage = () => {

  const dispatch = useDispatch<AppDispatch>();

  // Usa useSelector para acceder al estado 'status' de tu slice de autenticación
  const { status, errorMessage } = useSelector((state: RootState) => state.auth);

  const isChecking = status === 'checking';

  const { register, handleSubmit, watch, formState: { errors } } = useForm<Inputs>({
    defaultValues: {
      name: '',
      email: '',
      password: '',
      acceptTerms: false,
    }
  });


  const onSubmit = (data: Inputs) => {

    dispatch(startRegisterNormalUser(data.email, data.password, data.name));

  };

  // Verificamos si el checkbox de términos está marcado
  const termsAccepted = watch("acceptTerms");


  // Estado para controlar si la contraseña se muestra o no
  const [showPassword, setShowPassword] = useState(false);

  // Función para cambiar el estado de showPassword
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  // Función para manejar el mousedown en el IconButton
  const handleMouseDownPassword = (event: any) => {
    event.preventDefault();
  };


  return (

    <AuthLayout title="Crea tu cuenta" linkTo="login">
      <form onSubmit={handleSubmit(onSubmit)}>
        {isChecking ?
          <Grid
            container
            style={{}} // Establece la altura del contenedor al 100% del viewport
            alignItems="center" // Alinea verticalmente al centro
            justifyContent="center" // Alinea horizontalmente al centro
          >
            <CircularProgress style={{ color: '#d32f2f' }} />
          </Grid>
          :
          <Grid
            container
            alignItems="center"
            justifyContent="center"

          >

            <Grid item xs={11} mb={2}>
              <TextField
                label="Nombre"
                type='text'
                placeholder=''
                fullWidth
                {...register("name", {
                  required: "Este campo es requerido",
                  minLength: {
                    value: 3,
                    message: "El nombre debe tener al menos 3 caracteres"
                  }
                })}
                error={!!errors.name}
                helperText={errors.name?.message}
              />
            </Grid>

            <Grid item xs={11} mb={2}>
              <TextField
                label="Correo electrónico"
                type='email'
                placeholder='ejemplo@correo.com'
                fullWidth
                {...register("email", {
                  required: "Este campo es requerido",
                  pattern: {
                    value: regularExps.email,
                    message: "Este campo debe ser un correo electrónico válido"
                  }
                })}
                error={!!errors.email}
                helperText={errors.email?.message}
              />
            </Grid>

            <Grid item xs={11} mb={2}>
              <TextField
                label="Contraseña"
                type={showPassword ? 'text' : 'password'} placeholder='Tu contraseña' fullWidth
                {...register("password", {
                  required: "Este campo es requerido",
                  pattern: {
                    value: regularExps.password,
                    message: "La contraseña debe contener al menos una mayúscula, una minúscula y un número"
                  }
                })}
                error={!!errors.password}
                helperText={errors.password?.message}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }} />
            </Grid>

            <Grid item xs={11} mb={1} >
              <FormControlLabel
                control={
                  <Checkbox
                    {...register("acceptTerms", {
                      required: "Debes aceptar los términos y condiciones"
                    })}
                  />
                }
                label={
                  <span>
                    Aceptas los <Link color={'secondaryAccent.dark'} component={RouterLink} to={`/termsandconditions`} variant="body2">términos y condiciones</Link>
                  </span>
                }

              />
              <br />{errors.acceptTerms && <span style={{ color: '#d32f2f' }}>{errors.acceptTerms.message}</span>}
            </Grid>

            <Grid item xs={11} >


              <Grid item
                mb={2}
                display={errorMessage ? '' : 'none'}
              >
                <Alert severity='error' >
                  {errorMessage}
                </Alert>
              </Grid>

              <Button
                variant="contained"
                type="submit"
               
                fullWidth
                sx={{ bgcolor:'primary.light', borderRadius: 2, padding: 1.5, fontSize: '1.1rem' }}
                disabled={!termsAccepted}
              >
                Registrarse

              </Button>
            </Grid>


          </Grid>
        }
      </form>
    </AuthLayout >
  )

}
